// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/classes.css
// module id = 925
// module chunks = 0